module.exports = __webpack_public_path__ + "img/partner_logo13.21a97dbc.png";